import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Activity({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <Activity.Outline {...props} />
  ) : (
    <Activity.Solid {...props} />
  );
}

Activity.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.3235 4.20027C17.3235 2.72446 18.5199 1.52808 19.9957 1.52808C21.4715 1.52808 22.6679 2.72446 22.6679 4.20027C22.6679 5.67609 21.4715 6.87247 19.9957 6.87247C18.5199 6.87247 17.3235 5.67609 17.3235 4.20027ZM19.9957 3.02808C19.3483 3.02808 18.8235 3.55289 18.8235 4.20027C18.8235 4.84766 19.3483 5.37247 19.9957 5.37247C20.6431 5.37247 21.1679 4.84766 21.1679 4.20027C21.1679 3.55289 20.6431 3.02808 19.9957 3.02808Z"
          className="icon-outline"
        />
        <path
          d="M17.0409 9.20014C17.3683 9.45384 17.4281 9.92494 17.1744 10.2524L14.2453 14.0327C14.123 14.1906 13.9427 14.2932 13.7444 14.3177C13.5461 14.3422 13.3463 14.2865 13.1892 14.1631L10.3707 11.9492L7.83957 15.2389C7.58698 15.5672 7.11609 15.6286 6.7878 15.376C6.45952 15.1234 6.39815 14.6525 6.65074 14.3242L9.64387 10.4341C9.76597 10.2754 9.94644 10.1721 10.1451 10.1472C10.3438 10.1223 10.5441 10.1779 10.7016 10.3016L13.522 12.5171L15.9887 9.33364C16.2424 9.00621 16.7135 8.94644 17.0409 9.20014Z"
          className="icon-outline"
        />
        <path
          d="M7.65704 2.37012C5.96515 2.37012 4.53822 2.97449 3.53838 4.05302C2.54448 5.12514 2.02832 6.60468 2.02832 8.26428V16.3467C2.02832 18.0025 2.53314 19.4807 3.5239 20.5525C4.52127 21.6316 5.94986 22.2317 7.65704 22.2317H16.2612C17.952 22.2317 19.3789 21.6303 20.3792 20.554C21.3736 19.484 21.8899 18.0064 21.8899 16.3467V9.30776C21.8899 8.89355 21.5541 8.55776 21.1399 8.55776C20.7257 8.55776 20.3899 8.89355 20.3899 9.30776V16.3467C20.3899 17.6984 19.9725 18.7883 19.2804 19.5329C18.5942 20.2713 17.5817 20.7317 16.2612 20.7317H7.65704C6.31616 20.7317 5.30539 20.27 4.62542 19.5344C3.93884 18.7916 3.52832 17.7023 3.52832 16.3467V8.26428C3.52832 6.91244 3.9458 5.8199 4.6384 5.0728C5.32506 4.33211 6.33748 3.87012 7.65704 3.87012H14.9248C15.339 3.87012 15.6748 3.53433 15.6748 3.12012C15.6748 2.7059 15.339 2.37012 14.9248 2.37012H7.65704Z"
          className="icon-outline"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Activity.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          opacity="0.4"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.2428 2.73756C13.2428 4.95855 15.0459 6.75902 17.2702 6.75902C17.5151 6.75782 17.7594 6.73431 18 6.68878V14.6615C18 18.0156 16.0215 20 12.6624 20H5.34636C1.97851 20 0 18.0156 0 14.6615V7.3561C0 4.00195 1.97851 2 5.34636 2H13.3131C13.2659 2.243 13.2423 2.49001 13.2428 2.73756ZM11.15 12.8966L14.0078 9.20878V9.19122C14.2525 8.86247 14.1901 8.39889 13.8671 8.14634C13.7108 8.02568 13.5122 7.97345 13.3167 8.00159C13.1211 8.02972 12.9453 8.1358 12.8295 8.29561L10.4201 11.3951L7.6766 9.23512C7.51997 9.11309 7.32071 9.05922 7.12381 9.08565C6.92691 9.11208 6.74898 9.2166 6.63019 9.37561L3.67562 13.1863C3.57177 13.3158 3.51586 13.4771 3.51734 13.6429C3.5002 13.9781 3.71187 14.2826 4.03238 14.3838C4.35288 14.485 4.70138 14.3573 4.88031 14.0732L7.35125 10.8771L10.0948 13.0283C10.2508 13.1541 10.4514 13.2111 10.6504 13.1863C10.8494 13.1615 11.0297 13.0569 11.15 12.8966Z"
          className="icon-secondary"
        />
        <path
          d="M14.008 9.20879L11.1502 12.8966C11.03 13.0569 10.8496 13.1615 10.6506 13.1863C10.4516 13.2111 10.251 13.1541 10.095 13.0283L7.35147 10.8771L4.88054 14.0732C4.70161 14.3573 4.35311 14.485 4.03261 14.3838C3.7121 14.2826 3.50043 13.9781 3.51757 13.6429C3.51609 13.4771 3.572 13.3158 3.67585 13.1863L6.63042 9.37562C6.74921 9.21661 6.92714 9.11209 7.12404 9.08566C7.32094 9.05922 7.52019 9.1131 7.67683 9.23513L10.4204 11.3951L12.8297 8.29562C12.9456 8.13581 13.1213 8.02972 13.3169 8.00159C13.5124 7.97346 13.711 8.02569 13.8674 8.14635C14.1903 8.3989 14.2527 8.86247 14.008 9.19123V9.20879Z"
          className="icon-primary"
        />
        <circle cx="17.5" cy="2.5" r="2.5" className="icon-primary" />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
